import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import { getStyle } from '../style-marshal/types.tsx';
import * as classNames from './classnames';

export const getRowStyle = (id: IssueId, parentId?: IssueId) => {
	const rowClassName = classNames.row(id);
	const classes =
		parentId !== undefined ? [rowClassName, classNames.rowChild(parentId)] : rowClassName;

	return getStyle(classes);
};
